import WhatsappRepository from "../repository/whatsapp_repository";

class WhatsappService {
	constructor() {
		this.repository = new WhatsappRepository();
	}

	async getMensagens(unidadeDistribuidoraId, page = 1, limit = 50) {
		return this.repository.getMensagens(unidadeDistribuidoraId, page, limit);
	}

	async getEstatisticas(unidadeDistribuidoraId, dia) {
		return this.repository.getEstatisticas(unidadeDistribuidoraId, dia);
	}

	async enviarMensagens(unidadeDistribuidoraId, dataAlvo, fornecedorIds, dataLimiteRetificacao, cultivoIds, horaLimiteRetificacao) {
		return this.repository.enviarMensagens(unidadeDistribuidoraId, dataAlvo, fornecedorIds, dataLimiteRetificacao, cultivoIds, horaLimiteRetificacao);
	}

	async listarCulturas(unidadeDistribuidoraId) {
		return this.repository.listarCulturas(unidadeDistribuidoraId);
	}

	async reenviarMensagem(id) {
		return this.repository.reenviarMensagem(id);
	}

	async reenviarPendentes(unidadeDistribuidoraId) {
		return this.repository.reenviarPendentes(unidadeDistribuidoraId);
	}

	async vincularColeta(mensagemId, coletaId) {
		return this.repository.vincularColeta(mensagemId, coletaId);
	}

	async listarAgendamentos(unidadeDistribuidoraId) {
		return this.repository.listarAgendamentos(unidadeDistribuidoraId);
	}

	async criarAgendamento(data) {
		return this.repository.criarAgendamento(data);
	}

	async atualizarAgendamento(id, data) {
		return this.repository.atualizarAgendamento(id, data);
	}

	async excluirAgendamento(id) {
		return this.repository.excluirAgendamento(id);
	}
}

export default WhatsappService;
